import React, { useState, useEffect, useCallback, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Popup from 'reactjs-popup';
import ProcessWorkflow from './ProcessWorkflow';
import Loader from '../../Loader';
import { UserService } from '../../../service/user.service';

import '../../../../node_modules/reactjs-popup/dist/index.css';
import '../../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';

const WorkflowMonitor = () => {
    const gridRef = useRef();
    const [rowData, setRowData] = useState();
    const [loading, setLoading] = useState(true);
    const [pageLoading, setPageLoading] = useState(false);

    const userService = new UserService();

    const gridCellRenderer = (params) => {
        if (params.value) {
            let _value = '<span title="' + params.value + '">' + params.value + '</span>';
            return <div dangerouslySetInnerHTML={{ __html: _value }}></div>;;
        }
    }

    const editCellRenderer = (params) => {
        let html = '<a title="Edit User" style="color:#007bff;"><i class="fa fa-edit"></i></a>';
        return <Popup trigger={<div dangerouslySetInnerHTML={{ __html: html }}></div>} nested modal>{close => (<ProcessWorkflow callBack={reloding} data={params.data} onClose={() => { close(); }}></ProcessWorkflow>)}</Popup>;
    };

    const columnDefs = [
        /*{ headerName: 'User Name', field: 'name', filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },*/
        { headerName: 'Email', field: 'email', filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Company', field: 'company.name', filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Application', field: 'applicationName', filter: true, floatingFilterComponent: 'applicationColCellRenderer', cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Type', width: 100, field: 'requestType', filter: true, suppressSizeToFit: true, sortable: false, floatingFilterComponent: 'requestTypeColCellRenderer', cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Status', width: 195, field: 'status', filter: true, suppressSizeToFit: true, sortable: false, floatingFilterComponent: 'requestStatusColCellRenderer', cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Failed reason', field: 'reasonFailed', filter: false, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: '', field: '', colId: 'edit-button', width: 30, suppressSizeToFit: true, sortable: false, cellRenderer: p => editCellRenderer(p), resizable: true }
    ];

    const cellClickedListener = useCallback(event => {
        if (event.colDef.field === 'edit-button') {
            alert("You want to edit: " + event.data.id);
        }
        else if (event.colDef.field === 'delete-button') {
            alert("You want to delete: " + event.data.id);
        }
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (loading === true) {
                setPageLoading(true);
                const result = await userService.getUserRequests();
                if (result.status === 200) {
                    let data = result.data.data.map((ru) => {
                        return {
                            id: ru.id,
                            applicationId: ru.applicationId,
                            application: ru.application,
                            email: ru.email,
                            supervisorEmail: ru.supervisorEmail,
                            supervisorName: ru.supervisorName,
                            name: (ru.firstName + " " + ru.lastName),
                            firstName: ru.firstName,
                            lastName: ru.lastName,
                            status: ru.status,
                            dateCreated: ru.dateCreated,
                            companyId: ru.companyId,
                            company: ru.company,
                            requestType: ru.requestType,
                            title: ru.title,
                            department: ru.department,
                            city: ru.city,
                            reasonFailed: ru.reasonFailed,
                            userRequestHistories: ru.userRequestHistories,
                            sponsorEmail: ru.sponsorEmail,
                            sponsorName: ru.sponsorName,
                            sponsorCompanyId: ru.sponsorCompanyId,
                            applicationName: ru.application.name,
                            companyName: ru.company.name,
                            phone: ru.phone,
                            reasonForRequest: ru.reasonForRequest,
                            password: ru.password,
                            ApproverRemarks: ru.ApproverRemarks,
                            ApplicationName: ru.application.name
                        };
                    });

                    setRowData(data);
                    setLoading(false);
                    gridRef.current.api.sizeColumnsToFit();

                    setPageLoading(false);
                }
            }
        }

        fetchData()
            .catch(console.error);

    }, [loading]);

    const gridOptions = {
        columnDefs: columnDefs,
        pagination: true,
        rowSelection: 'single',
        enableFilter: true,
        cacheBlockSize: 25,
        paginationPageSize: 25,
        getRowHeight: (params) => 25
    };

    const reloding = () => {
        setLoading(true);
    };

    return (
        <div className="card">
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> Workflow Monitor
            </h5>
            <div className="card-body" style={{ height: "75vh" }}>
                {pageLoading && <Loader />}
                <div className="ag-theme-alpine" style={{ height: "100%" }}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        onCellClicked={cellClickedListener}
                        gridOptions={gridOptions} />
                </div>
            </div>
        </div>
    );
};

export default WorkflowMonitor;